import { BizzeySetting } from "../../../packs/widget_shim";
import { PublicLocale } from "../../types";
import { CookieHelper } from "../helpers";
import store from "../store";

class BaseController {
  static BASE_URL = "https://widget.bizzey.com";
  static APP_ID = "=== APP ID ==="

  static DEFAULT_HEADERS = {
    "Accept": "application/json",
    "Content-Type": "application/json",
  }

  static configure(config: BizzeySetting) {
    this.BASE_URL = config.api_base
    this.APP_ID = config.app_id
  }

  static async post<T>(path: string, data: object = {}): Promise<T> {
    const deviceId = CookieHelper.getDeviceId(this.APP_ID) || null
    const anonymousId = CookieHelper.getAnonymousIdentifier(this.APP_ID) || null
    const bizzeySetting = store?.getState().application?.bizzeySetting
    const userId = bizzeySetting?.user_id || null
    const name = bizzeySetting?.name || null
    const email = bizzeySetting?.email || null
    const createdAt = bizzeySetting?.created_at || null
    const locale = store.getState().application.locale || PublicLocale.EN

    return fetch(`${this.BASE_URL}${path}`, {
      method: "POST",
      headers: { ...this.DEFAULT_HEADERS, },
      body: JSON.stringify({
        app_id: this.APP_ID,
        device_id: deviceId,
        anonymous_id: anonymousId,
        session_id: userId,
        page_title: document.title,
        referer: window.location.href,
        user_data: {
          id: userId,
          name: name,
          email: email,
          locale: locale,
          created_at: createdAt,
        },
        ...data,
      }),
    }).then((res) => res.json());
  }
}

export default BaseController;